class Core {
  constructor() {
    this.currentTimeout = null;
  }
  wait(timeout) {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }
    return new Promise((resolve) => {
      this.currentTimeout = setTimeout(resolve, timeout);
    });
  }
}

function updateMilestone() {
  const totalScoreEl = document.querySelector('.milestone .total-score');
  const bar = document.querySelector('.milestone .milestone-bar');
  const fill = document.querySelector('.milestone .runbar-fill');
  const items = Array.from(document.querySelectorAll('.list-milestone li'));

  if (!totalScoreEl || !bar || !fill || !items.length) return;

  const score = parseInt(totalScoreEl.textContent.replace(/[^0-9]/g, ''), 10) || 0;

  // Đánh dấu mốc đã đạt
  items.forEach(function(li) {
    const val = parseInt(li.getAttribute('data-value'), 10);
    li.classList.toggle('done', score >= val);
  });

  // Đo vị trí pixel thực tế của từng li (center) so với bar
  const barRect = bar.getBoundingClientRect();

  function getLiCenter(li) {
    const r = li.getBoundingClientRect();
    return r.left + r.width / 2 - barRect.left;
  }

  const vals = items.map(li => parseInt(li.getAttribute('data-value'), 10));
  const maxVal = vals[vals.length - 1];

  // Score vượt mốc cuối: fill 100%
  if (score > maxVal) {
    fill.style.width = '100%';
    return;
  }

  // Score đúng bằng mốc cuối
  if (score === maxVal) {
    fill.style.width = getLiCenter(items[items.length - 1]) / barRect.width * 100 + '%';
    return;
  }

  // Score chưa tới mốc đầu
  if (score < vals[0]) {
    const firstCenter = getLiCenter(items[0]);
    fill.style.width = (score / vals[0]) * firstCenter / barRect.width * 100 + '%';
    return;
  }

  // Nội suy giữa 2 mốc liền kề
  for (let i = 0; i < items.length - 1; i++) {
    if (score >= vals[i] && score < vals[i + 1]) {
      const pos1 = getLiCenter(items[i]);
      const pos2 = getLiCenter(items[i + 1]);
      const t = (score - vals[i]) / (vals[i + 1] - vals[i]);
      const px = pos1 + t * (pos2 - pos1);
      fill.style.width = px / barRect.width * 100 + '%';
      return;
    }
  }
}

window.addEventListener("load", function () {
  updateMilestone();

  const dndPromotion = window.libraryMainsite.promotion;
  let globalCount;
  const popupReward = document.querySelector('#popup_reward');
  if (popupReward) {
    new MutationObserver(function () {
      if (popupReward.classList.contains('active')) {
        const eggEl = document.querySelector('.egg-effect');
        if (eggEl) eggEl.classList.remove('open', 'shaking');
      }
    }).observe(popupReward, { attributes: true, attributeFilter: ['class'] });
  }

  async function animationRandom() {
    const eggEl = document.querySelector('.egg-effect');
    if (!eggEl) return;

    eggEl.classList.remove('open', 'shaking');
    void eggEl.offsetWidth;

    eggEl.classList.add('shaking');

    await new Promise(resolve => setTimeout(resolve, 2000));
    eggEl.classList.add('open');

    await new Promise(resolve => setTimeout(resolve, 500));
    eggEl.classList.remove('shaking');
  };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 3000,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom();
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            // globalCount = 10;

        },
    });
  
});